import { FC } from 'react';

import ConversionAge from 'src/components/Conversion/Age';

interface Props {
    age: number;
}

const Age: FC<Props> = ({ age }) => {
    return (
        <span data-qa="resume-serp__resume-age">
            <ConversionAge value={age} />
        </span>
    );
};

export default Age;
